import { IconV1 } from 'common/icon/iconV1.js';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import React from 'react';
import { useAppSelector } from 'redux-state/configure-store.js';
import { isOneCol } from 'utilities/media-queries';

/** tiny popup children MUST support forwardRef */
export const FavPopupChildManageFavs = React.forwardRef<HTMLDivElement>((_, ref) => {
  const isOneColumn = isOneCol(React.useContext(ScreenSizeContext));
  const { allItems: favAll, bottomItems: favBottom } = useAppSelector((s) => s.FAVOURITES);

  /** favourites-menu-full when a favourite can no longer be displayed on the search bar.
   * This changes depending on the screen size.
   * The idea is to indicate too user that their favourite has over flown into the fav menu */

  return (
    <div ref={ref}>
      <IconV1
        size={32}
        icon={favBottom.length || (isOneColumn && favAll.length) ? 'favourites-menu-full' : 'favourites-menu'}
        iconClass="svg--fill-inherit svg-fill-textSlate svg--fill-hover"
      />
    </div>
  );
});
